import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const EscalatorIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M49.2783 110.802V72.3993C49.2783 63.9157 56.1556 57.0383 64.6393 57.0383C73.1229 57.0383 80.0002 63.9157 80.0002 72.3993V83.92" stroke={color} strokeWidth="6" />
            <path
                d="M128.004 64.7189H104.915C102.916 64.7189 101.448 65.0583 99.581 66.738C99.2408 67.0442 46.6765 114.309 46.6765 114.309C46.4383 114.524 46.1291 114.642 45.8086 114.642H31.9984C24.5753 114.642 18.5576 120.66 18.5576 128.083C18.5576 135.506 24.5753 141.524 31.9984 141.524H56.7567C58.0398 141.524 58.8983 141.052 59.5115 140.439L113.326 91.9332C113.564 91.7189 113.874 91.6006 114.194 91.6006H128.004C135.428 91.6006 141.445 85.5829 141.445 78.1598C141.445 70.7366 135.428 64.7189 128.004 64.7189Z"
                stroke={color}
                strokeWidth="6"
            />
            <path
                d="M64.6389 45.5177C71.0016 45.5177 76.1596 40.3597 76.1596 33.997C76.1596 27.6343 71.0016 22.4763 64.6389 22.4763C58.2762 22.4763 53.1182 27.6343 53.1182 33.997C53.1182 40.3597 58.2762 45.5177 64.6389 45.5177Z"
                stroke={color}
                strokeWidth="6"
            />
        </svg>
    );
};
